<ion-header
  class="ion-no-border"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      slot="end"
    >
      <ion-button data-cy="will-call-close-modal-icon" (click)="cancel()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <h2 *ngIf="!editMode; else wcEditMode" data-cy="will-call-modal-label">
      {{ 'i18n.convertToWillCall.convertOrderToWillCall' | translate }}
    </h2>

    <div
      class="alert-message"
      *ngIf="!editMode"
      data-cy="will-call-final-label"
    >
      <ion-icon name="alert-circle-outline"></ion-icon>
      <p>
        {{ 'i18n.convertToWillCall.convertWillCallFinal' | translate }}
      </p>
    </div>

    <ng-template #wcEditMode>
      <h2 data-cy="will-call-details-label">
        {{ 'i18n.convertToWillCall.willCallOrderDetails' | translate }}
      </h2>
    </ng-template>

    <div class="customer-name" data-cy="will-call-customer-text">
      {{ customer?.customerName | titlecase }} ({{ customer?.customerNumber }})
    </div>
  </ion-toolbar>
</ion-header>

<ion-content
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
  [scrollY]="true"
>
  <form [formGroup]="willCallForm" #form="ngForm">
    <!-- DESKTOP/TABLET -->
    <ion-grid
      *ngIf="
        platformService.platformType !== platformService.platformEnum.mobile
      "
    >
      <ion-row>
        <ion-col>
          <ion-label id="will-call-name" class="custom-input-label"
            >{{ 'i18n.convertToWillCall.personPickingUp' | translate
            }}<span>*</span></ion-label
          >
          <ion-input
            id="usf-line-input-style"
            aria-labelledby="will-call-name"
            label-placement="stacked"
            formControlName="customerName"
            placeholder="Name"
            maxLength="25"
            data-cy="will-call-customer-input"
          >
          </ion-input>
          <ion-note
            class="validation-message"
            *ngIf="
              willCallForm.controls.customerName.touched &&
              !willCallForm.controls.customerName.valid
            "
            data-cy="will-call-name-note"
          >
            <ion-icon name="alert-circle-outline"></ion-icon>
            {{ 'i18n.convertToWillCall.nameLengthError' | translate }}
          </ion-note>

          <ion-label id="special-instructions" class="custom-input-label">{{
            'i18n.convertToWillCall.specialInstructions' | translate
          }}</ion-label>
          <ion-input
            id="usf-line-input-style"
            aria-labelledby="special-instructions"
            label-placement="stacked"
            placeholder=""
            maxlength="100"
            formControlName="specialInstructions"
            data-cy="will-call-instructions-input"
          >
          </ion-input>
          <span class="character-count" data-cy="will-call-instructions-count"
            >{{ willCallForm?.value?.specialInstructions.length }}/100</span
          >

          <ion-label
            id="customer-po"
            class="readonly-label"
            data-cy="will-call-type-label"
          >
            {{ 'i18n.convertToWillCall.customerPo' | translate }}
          </ion-label>
          <ion-input
            readonly
            id="usf-line-input-style-readonly"
            label-placement="stacked"
            placeholder=""
            formControlName="customerPo"
            data-cy="will-call-customerpo-input"
          ></ion-input>

          <ion-label id="will-call-name" class="custom-input-label"
            >{{ 'i18n.convertToWillCall.willCallType' | translate
            }}<span>*</span></ion-label
          >
          <div class="will-call-type">
            <ion-radio-group
              [allowEmptySelection]="true"
              formControlName="willCallType"
            >
              <ion-radio
                labelPlacement="end"
                justify="start"
                value="customer"
                mode="md"
                data-cy="will-call-type-customer-input"
              >
                {{ 'i18n.convertToWillCall.customer' | translate }}
              </ion-radio>
              <ion-radio
                labelPlacement="end"
                justify="start"
                value="seller"
                mode="md"
                data-cy="will-call-type-seller-input"
              >
                {{ 'i18n.convertToWillCall.seller' | translate }}
              </ion-radio>
            </ion-radio-group>
          </div>
        </ion-col>
        <ion-col>
          <ion-label
            class="required-label is-required"
            data-cy="will-call-pickup-label"
          >
            {{ 'i18n.convertToWillCall.pickupDateTime' | translate }}
          </ion-label>

          <div class="original-date" data-cy="will-call-original-date-text">
            {{ 'i18n.convertToWillCall.originalDate' | translate }}
            {{ willCallForm.controls.originalDeliveryDate.value }}
          </div>

          <div class="selected-date" data-cy="will-call-selected-date-text">
            <span>{{ 'i18n.convertToWillCall.selectedDate' | translate }}</span>
            <ng-container *ngIf="!isCalendarChanged; else elseBlock">
              {{
                willCallForm.controls.pickupDateTime.value
                  | date: "M/d/yyyy 'at' h:mm a" : 'GMT'
                  | lowercase
              }}
            </ng-container>
            <ng-template #elseBlock>
              {{
                willCallForm.controls.pickupDateTime.value
                  | date: "M/d/yyyy 'at' h:mm a"
                  | lowercase
              }}
            </ng-template>
          </div>
          <div class="calendar-container">
            <ion-datetime
              value="willCallForm.controls.pickupDateTime.value"
              formControlName="pickupDateTime"
              [min]="minPickupDate"
              [max]="maxPickupDate"
              mode="ios"
              size="cover"
              data-cy="will-call-calendar"
              [preferWheel]="true"
              (ionChange)="ionChange(true)"
            ></ion-datetime>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- MOBILE -->
    <ion-grid
      *ngIf="
        platformService.platformType === platformService.platformEnum.mobile
      "
    >
      <ion-row>
        <ion-col>
          <ion-label
            class="required-label is-required"
            data-cy="will-call-pickup-label"
          >
            {{ 'i18n.convertToWillCall.pickupDateTime' | translate }}
          </ion-label>

          <div class="original-date" data-cy="will-call-original-date-text">
            {{ 'i18n.convertToWillCall.originalDate' | translate }}
            {{ willCallForm.controls.originalDeliveryDate.value }}
          </div>

          <div class="selected-date" data-cy="will-call-selected-date-text">
            <span>{{ 'i18n.convertToWillCall.selectedDate' | translate }}</span>
            <ng-container *ngIf="!isCalendarChanged; else elseBlock">
              {{
                willCallForm.controls.pickupDateTime.value
                  | date: "M/dd/yyyy 'at' h:mm a" : 'GMT'
              }}
            </ng-container>
            <ng-template #elseBlock>
              {{
                willCallForm.controls.pickupDateTime.value
                  | date: "M/dd/yyyy 'at' h:mm a"
              }}
            </ng-template>
          </div>

          <ion-datetime
            value="willCallForm.controls.pickupDateTime.value"
            formControlName="pickupDateTime"
            [min]="minPickupDate"
            [max]="maxPickupDate"
            mode="ios"
            size="cover"
            data-cy="will-call-calendar"
            [preferWheel]="true"
            (ionChange)="ionChange(true)"
          ></ion-datetime>

          <ion-label
            id="will-call-name"
            class="custom-input-label"
            data-cy="will-call-pickup-label"
          >
            {{ 'i18n.convertToWillCall.personPickingUp' | translate }}
            <span>*</span>
          </ion-label>
          <ion-input
            aria-labelledby="will-call-name"
            placeholder="Name"
            formControlName="customerName"
            maxLength="25"
            data-cy="will-call-customer-input"
          >
          </ion-input>
          <ion-note
            class="validation-message"
            *ngIf="
              willCallForm.controls.customerName.touched &&
              !willCallForm.controls.customerName.valid
            "
            data-cy="will-call-name-note"
          >
            <ion-icon name="alert-circle-outline"></ion-icon>
            {{ 'i18n.convertToWillCall.nameLengthError' | translate }}
          </ion-note>

          <ion-label id="special-instructions" class="custom-input-label">
            {{ 'i18n.convertToWillCall.specialInstructions' | translate }}
          </ion-label>
          <ion-input
            aria-labelledby="special-instructions"
            placeholder=""
            maxlength="100"
            formControlName="specialInstructions"
            data-cy="will-call-instructions-input"
          >
          </ion-input>
          <span class="character-count" data-cy="will-call-instructions-count"
            >{{ willCallForm?.value?.specialInstructions.length }}/100</span
          >

          <ion-label class="readonly-label" data-cy="will-call-type-label">
            {{ 'i18n.convertToWillCall.customerPo' | translate }}
          </ion-label>
          <ion-input
            readonly
            placeholder=""
            formControlName="customerPo"
            data-cy="will-call-customerpo-input"
          ></ion-input>

          <ion-label
            class="custom-input-label"
            data-cy="will-call-customer-po-label"
          >
            {{ 'i18n.convertToWillCall.willCallType' | translate }}
            <span>*</span></ion-label
          >
          <div class="will-call-type">
            <ion-radio-group
              formControlName="willCallType"
              [allowEmptySelection]="true"
            >
              <ion-radio
                labelPlacement="end"
                justify="start"
                value="customer"
                mode="md"
                data-cy="will-call-type-customer-input"
              >
                {{ 'i18n.convertToWillCall.customer' | translate }}
              </ion-radio>
              <ion-radio
                labelPlacement="end"
                justify="start"
                value="seller"
                mode="md"
                data-cy="will-call-type-seller-input"
              >
                {{ 'i18n.convertToWillCall.seller' | translate }}
              </ion-radio>
            </ion-radio-group>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="
    (platformService?.isTouchExperience$ | async) === false
  "
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        [ngClass]="
          platformService.platformType !== platformService.platformEnum.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        data-cy="cancel-will-call-button"
        (click)="cancel()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        *ngIf="!editMode; else wcEditModeForButton"
        [ngClass]="
          platformService.platformType !== platformService.platformEnum.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        (click)="submit()"
        [disabled]="!willCallForm.valid || (isOnline$ | async) === false"
        data-cy="convert-will-call-button"
      >
        {{ 'i18n.convertToWillCall.convertOrder' | translate }}
      </ion-button>
      <ng-template #wcEditModeForButton>
        <ion-button
          [disabled]="!willCallForm.valid || (isOnline$ | async) === false"
          [ngClass]="
            platformService.platformType !== platformService.platformEnum.mobile
              ? 'usf-fill-green-dsktp-tblt-modal-button'
              : 'usf-fill-green-mobile-modal-button'
          "
          (click)="submit()"
          data-cy="open-will-call-confirm-button"
        >
          {{ 'i18n.common.apply' | translate }}
        </ion-button>
      </ng-template>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
